import { Resolution } from './Resolution';

export class SelectResolution {
    constructor(value: Resolution, label: string) {
        this.value = value;
        this.label = label;
    }
    value: Resolution;
    label: string;
}
